<template>
  <div v-if="showModal" class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" @click="showModal = false"></div>
    <div class="z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-5xl">
      <div class="flex-auto">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <Form v-if="form" class="text-base leading-relaxed text-gray-500 dark:text-gray-400"
                :validation-schema="formSchema" :initial-values="form"
                @submit="submit">
            <!-- header -->
            <div class="flex justify-between items-start p-5 rounded-t border-b">
              <h3 class="text-xl font-semibold text-gray-900 lg:text-xl dark:text-white">
                {{ $lang.app.EDIT }}
              </h3>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5
                ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <XIcon class="w-5 h-5"/>
              </button>
            </div>
            <!-- body -->
            <div class="p-6">
              <div class="mb-5 flex justify-start text-black">
                <label class="w-1/4 text-lg" for="name-ru-input">{{ $lang.app.TITLE_RU }}<span class="text-red-600">*</span></label>
                <div class="w-3/4 flex flex-col">
                  <Field id="name-ru-input"
                         name="nameRu"
                         type="text"
                         v-model="form.nameRu"
                         class="w-full">
                  </Field>
                  <ErrorMessage name="nameRu" class="text-xs text-red-400"/>
                </div>
              </div>
              <div class="mb-5 flex justify-start text-black">
                <label class="w-1/4 text-lg" for="name-kg-input">{{ $lang.app.TITLE_KG }}<span class="text-red-600">*</span></label>
                <div class="w-3/4 flex flex-col">
                  <Field id="name-kg-input"
                         name="nameKg"
                         type="text"
                         v-model="form.nameKg"
                         class="w-full">
                  </Field>
                  <ErrorMessage name="nameKg" class="text-xs text-red-400"/>
                </div>
              </div>
            </div>

            <!-- footer -->
            <div class="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
              <button
                  type="submit"
                  class="relative text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  :disabled="submitting"
              >
                {{ $lang.app.UPDATE }}
                <div v-if="submitting" class="absolute z-10 rounded-lg w-full h-full top-0 left-0 bg-blue-700 flex items-center justify-center">
                  <div class="block animate-spin">
                    <RefreshIcon class="w-6 h-6 mirror-y"/>
                  </div>
                </div>
              </button>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900"
              >
                {{ $lang.app.CANCEL }}
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getValueByKey as modelStatusesGetValueByKey} from "../../../../helpers/constants/modelStatuses";
import * as yup from "yup";
import {ErrorMessage, Field, Form} from "vee-validate";
import locationCategoryApi from "../../../../api/admin/locationCategory";

export default {
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      showModal: false,
      submitting: false,
      form: null,
      formSchema: yup.object({
        nameRu: yup.string().required(),
        nameKg: yup.string().required(),
      }),
    }
  },
  methods: {
    modelStatusesGetValueByKey,
    submit() {
      this.submitting = true
      locationCategoryApi
          .update(this.form.id, {
            nameRu: this.form.nameRu,
            nameKg: this.form.nameKg,
            status: this.form.status,
          })
          .then(() => {
            this.showModal = false
            this.$emit('updated')
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          }).finally(() => {
        this.submitting = false
      });
    },
  },
  beforeMount() {
    this.$emitter.on('open-admin-edit-location-category-modal', item => {
      locationCategoryApi.detail(item.id).then(res => {
        this.form = {
          id: res.id,
          nameRu: res.nameRu,
          nameKg: res.nameKg,
          status: res.status,
        }
        this.showModal = true
      })
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-admin-edit-location-category-modal')
  }
};
</script>
